import { isElevated, RISK_TIERS, topDrivers } from './riskTiers';

/**
 * Regional summary for the filtered charter rows: the share at Moderate or
 * higher risk, counts per tier, and how often each measure is a top-2 driver.
 */
export function riskInsights(rows) {
  const scored = (rows || []).filter((row) => row.points !== null);
  const tierCounts = Object.fromEntries(RISK_TIERS.map((tier) => [tier.id, 0]));
  scored.forEach((row) => {
    tierCounts[row.tier.id] = (tierCounts[row.tier.id] || 0) + 1;
  });
  const elevatedCount = scored.filter((row) => isElevated(row.tier)).length;

  const driverCounts = new Map();
  scored
    .filter((row) => isElevated(row.tier))
    .forEach((row) => {
      topDrivers(row, 2).forEach((driver) => {
        const current = driverCounts.get(driver.id) || { id: driver.id, label: driver.label, count: 0 };
        current.count += 1;
        driverCounts.set(driver.id, current);
      });
    });

  return {
    total: scored.length,
    elevatedCount,
    elevatedPct: scored.length ? elevatedCount / scored.length : null,
    tierCounts,
    drivers: [...driverCounts.values()].sort((a, b) => b.count - a.count).slice(0, 3),
  };
}
